import React, { useState, useEffect, useContext } from "react";
import CompanyAppAccessReadOnlyRow from "./CompanyAppAccessReadOnlyRow";
import CompanyAppAccessTableRow from "./CompanyAppAccessTableRow";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

function CompanyAppAccessTable({ key, setAppAccess, appAccess, appNames, companyId, refetch }) {
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const [companyAppAccess, setCompanyAppAccess] = useState([]);
	const [appAccessLoaded, setAppAccessLoaded] = useState(false);
	const [subkeyCount, setSubkeyCount] = useState(key);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		companyId: companyId,
		appName: "",
		subscriptionDate: ""
	};
	const [formValues, setFormValues] = useState(initialValues);

	useEffect(() => {
		fetchCompanyAppAccess();
	}, []);

	const handleClose = (event) => {
		setAppAccess(false);
	};

	function fetchCompanyAppAccess() {
		setAppAccessLoaded(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, companyId: companyId }),
		};
		try {
			FetchUtil.fetchAPI("GetCompanyAppAccess", "/Service/CompanyService/GetCompanyAppAccess", requestOptions, getAppAccessSuccess, getAppAccessFail);
		} catch (error) {
			setErrorValue(error.message);
		}
	}

	function getAppAccessFail(redirect) {
		setErrorValue(t("error.getAppNamesFailed"));
	}
	function getAppAccessSuccess(responseData) {
		let getCompanyAppAccessResponse;
		if (responseData) {
			getCompanyAppAccessResponse = responseData.getCompanyAppAccessResponse;
			if (getCompanyAppAccessResponse && getCompanyAppAccessResponse.errorCode === "0") {
				setCompanyAppAccess(getCompanyAppAccessResponse.appAccessList.slice());
				setAppAccessLoaded(true);
			} else if (getCompanyAppAccessResponse && getCompanyAppAccessResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCompanyAppAccessResponse) {
				setErrorValue(t("error.error") + " " + getCompanyAppAccessResponse.errorMessage);
			}
		}
	}
	const handleDeleteClick = (event, appAccessItem, completeCallback) => {
		event.preventDefault();
		deleteCompanyAppAccess(appAccessItem, completeCallback);
	};
	const deleteCompanyAppAccess = (appAccessItem, completeCallback) => {
		let action = 3;
		if (appAccessItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			companyId: companyId,
			appNameToChange: appAccessItem.appName,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteCompanyAppAccess", "/Service/CompanyService/DeleteCompanyAppAccess", requestOptions, deleteCompanyAppAccessSuccess, deleteCompanyAppAccessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteCompanyAppAccessFail(redirect, completeCallback) {
		setError(t("error.appAccessEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteCompanyAppAccessSuccess(responseData, completeCallback) {
		let deleteCompanyAppAccessResponse;
		if (responseData) {
			deleteCompanyAppAccessResponse = responseData.deleteCompanyAppAccessResponse;
			if (deleteCompanyAppAccessResponse) {
				if (deleteCompanyAppAccessResponse.errorCode === "0") {
					resetRowTable();
					//setAppAccess(false);
					refreshCompanyAppAccess();
				} else {
					setError(t("error.error") + " " +
						deleteCompanyAppAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};

	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.companyId) {
			setError(t("error.companyNameReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (companyAppAccess.length > 0) {
				companyAppAccess.map((appAccessItem, index) => {
					if (appAccessItem.appName === setValues.appName) {
						setError(t("error.appAccessDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveCompanyAppAccess(action, setValues, completeCallback);
			}
		} else {
			saveCompanyAppAccess(action, setValues, completeCallback);
		}
	};
	const saveCompanyAppAccess = (action, setValues, completeCallback) => {
		let serverParams = {
			companyId: formValues.companyId,
			appNameToChange: setValues.appName,
			subscriptionDate: setValues.subscriptionDate,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("SaveCompanyAppAccess", "/Service/CompanyService/SaveCompanyAppAccess", requestOptions, saveCompanyAppAccessSuccess, saveCompanyAppAccessFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveCompanyAppAccessFail(redirect, completeCallback) {
		setError(t("error.appAccessEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveCompanyAppAccessSuccess(responseData, completeCallback) {
		let saveCompanyAppAccessResponse;
		if (responseData) {
			saveCompanyAppAccessResponse = responseData.saveCompanyAppAccessResponse;
			if (saveCompanyAppAccessResponse) {
				if (saveCompanyAppAccessResponse.errorCode === "0") {
					resetRowTable();
					//setAppAccess(false);
					refreshCompanyAppAccess();
				} else {
					setError(t("error.error") + " " +
						saveCompanyAppAccessResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshCompanyAppAccess() {
		setSubkeyCount(prevCount => prevCount + 1);
		refetch();
		fetchCompanyAppAccess();
	}
	return (
		<>
			{userCtx.role === "SiteAdmin" ?
				<div key={key} className="modalContainer hide-scrollbar">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.application")}</th>
										<th className="list-th">{t("page.subDate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<CompanyAppAccessTableRow
											key={subkeyCount}
											appNames={appNames}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((companyAppAccess.length % 2) > 0) ? true : false} />
									}
									{(appAccessLoaded && (companyAppAccess.length > 0)) ? (
										companyAppAccess.map((appAccessItem, index) => (
											appAccessItem.appName !== "Customer" ?
												<CompanyAppAccessReadOnlyRow
													key={subkeyCount}
													t={t}
													appAccessItem={appAccessItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													add={add}
													setError={setError}
													handleSubmit={handleSubmit}
												/> : ""
										))
									) : (<></>)}
									{add && addRowBottom &&
										<CompanyAppAccessTableRow
											key={subkeyCount}
											appNames={appNames}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((companyAppAccess.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(companyAppAccess.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.application")}</th>
										<th className="list-th">{t("page.subDate")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-compapp-close"
									id="edit-compapp-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default CompanyAppAccessTable;